ambient.init({
	'sk-auto-collapse-nav': {width: { max: 1260 }},
	'sk-adjust-menu-columns': {height: {}},
	'sk-screen-small': {width: { max: 1100 }},
	'sk-screen-medium': {width: { min: 1100, max: 1260 }},
	'sk-screen-large': {width: { min: 1260 }},
}, 0);
